import {useAppSelector} from '../hooks/hooks'
import {locationHistory} from '../helpers/location-history'
import {Navigate} from 'react-router-dom'
import React, {PropsWithChildren} from 'react';

export const  PrivateZone = (props: PropsWithChildren) => {
    const { token } = useAppSelector(x => x.auth)
    return <>{!token ? <Navigate to="/login" state={{ from: locationHistory.location }} /> : props.children}</>
}
